module.exports = __webpack_public_path__ + "img/antenne-ktn-btn.ebc26ca9.svg";